export default __webpack_public_path__ + "static/media/Instagram.aec83684.png";